import { render, staticRenderFns } from "./boxGoodsSanIn.vue?vue&type=template&id=0738dc0a&scoped=true&"
import script from "./boxGoodsSanIn.vue?vue&type=script&lang=js&"
export * from "./boxGoodsSanIn.vue?vue&type=script&lang=js&"
import style0 from "./boxGoodsSanIn.vue?vue&type=style&index=0&id=0738dc0a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0738dc0a",
  null
  
)

component.options.__file = "boxGoodsSanIn.vue"
export default component.exports